import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { useBlackjackPlayers } from '../../../../classes/BlackjackAreaController';
import { useBlackjackAreaController } from '../../../../classes/TownController';
import useTownController from '../../../../hooks/useTownController';
import BlackjackArea from '../BlackjackArea';

export default function StartBlackjackGameModal({
  isOpen,
  onStartClick,
  blackjackArea,
}: {
  isOpen: boolean;
  onStartClick: () => void;
  blackjackArea: BlackjackArea;
}): JSX.Element {
  const toast = useToast();
  const townController = useTownController();
  const blackjackAreaController = useBlackjackAreaController(blackjackArea.name);

  townController.pause();
  const startGame = useCallback(async () => {
    blackjackAreaController.isGamePlaying = true;
    townController.emitBlackjackAreaUpdate(blackjackAreaController);
    onStartClick();
    toast({ title: 'Game started! Good luck!', status: 'success' });
  }, [blackjackAreaController, onStartClick, toast, townController]);

  const players = useBlackjackPlayers(blackjackAreaController);
  const names = [] as string[];
  const townPlayers = townController.players;
  players.forEach(eachPlayer => {
    const playerName = townPlayers.find(townPlayer => townPlayer.id === eachPlayer.id)?.userName;
    if (playerName) {
      names.push(playerName);
    }
  });
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        toast({ title: 'Cannot exit while in an active game', status: 'error' });
      }}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Press Start button to start the game</ModalHeader>
        <ModalBody pb={6}>
          <Text>All players:</Text>
          <>
            {names.map(name => {
              return (
                <>
                  <Text>{name}</Text>
                </>
              );
            })}
          </>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme='blue' mr={3} onClick={startGame}>
            Start
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
